import { FC } from "react";
import { useField } from "formik";
import { CustomerSelect } from "src/Controls";
import { IBaseField } from "./BaseField";

interface ICustomerProps extends IBaseField {
	setData: Function;
};


const Customer: FC<ICustomerProps> = ( { name, placeholder, disabled = false, setData } ) => {

	const [ inputProps, meta, helpers ] = useField( name );

	const onChangeHandler = ( value: string = "" ) => {
		helpers.setTouched(true);
		helpers.setValue(value, true);
		!!setData && setData((data: any) => {
			return { ...data, [name]: value }
		});
	};

	return (
		<CustomerSelect
			disabled={disabled}
			placeholder={placeholder}
			value={inputProps.value}
			setValue={ v => onChangeHandler(v?.id) }
			showClearBtn
			invalidate={!!( meta.touched && meta.error )}
		/>
	);
};

export default Customer;
